module.exports = __webpack_public_path__ + "static/media/2DGACM14.c4929902.jpg";